import React from 'react';
import Icon from '../../shared/Icon';
import { formatElapsed } from './ProgressRow';

export const STOPPED_TEXT = 'You stopped this answer.';
export const TIMEOUT_TITLE = 'The query timed out';
// The real limit (ORCH_RUN_TIMEOUT_S, 480s on dev); the copy states it (open questions 3 and 4).
export const RUN_LIMIT_MS = 8 * 60 * 1000;

/** PRD-1624: a stopped question keeps a line and a way forward, also after a reload. */
export function StoppedLine({ onTryAgain, disabled }) {
  return (
    <p className="iter1-stopped" data-testid="iter1-stopped">
      {STOPPED_TEXT}{' '}
      <button type="button" className="resui-link iter1-link-button" onClick={onTryAgain} disabled={disabled}>
        Try again
      </button>
    </p>
  );
}

/**
 * PRD-1624: the error states (Answer Presentation E8). A timeout says how long it ran; any
 * other failure gets its own title. Both offer Try again, so a question is never left with
 * nowhere to go.
 */
export function FailedAnswer({ outcome, onTryAgain, disabled }) {
  const timedOut = outcome.code === 'run_timeout';
  const ran = timedOut ? formatElapsed(outcome.elapsedMs || RUN_LIMIT_MS) : null;
  return (
    <div className="message assistant iter1-failed" role="alert" data-testid="iter1-failed">
      <div className="iter1-failed-card">
        <Icon name={timedOut ? 'clock-countdown' : 'warning-circle'} size={20} className="iter1-failed-glyph" />
        <div className="iter1-failed-body">
          <p className="iter1-failed-title">{timedOut ? TIMEOUT_TITLE : "This answer couldn't be completed"}</p>
          <p className="iter1-failed-text">
            {timedOut
              ? `It ran for ${ran} without finishing. Try a narrower question, or fewer datasets.`
              : (outcome.message || 'Something went wrong while preparing it.')}
          </p>
          <button type="button" className="resui-link iter1-link-button" onClick={onTryAgain} disabled={disabled}>
            Try again
          </button>
        </div>
      </div>
    </div>
  );
}
